import { useState } from "react";
import { useItemsFine } from "../_actions/app/items";
import { Card, Typography, Grid, Space, theme } from "antd";
import styles from "./styles/ScrollingChatTips.module.css";

const { Text } = Typography;
const { useBreakpoint } = Grid;

function ScrollingChatTips({ onSnippetClick, agent, setAgent }) {
    const screens = useBreakpoint();
    const { token } = theme.useToken();

    const { data, isLoading, error } = useItemsFine("qdb_chat_tips", "", true);

    console.log("ChatTips Data : ", data);

    const tips =
        Array.isArray(data) && data.length > 0
            ? data.map((item) => ({
                  key: item.agent || "default",
                  value: item.display_text || "",
              }))
            : [
                  { key: "linkedin", value: "Create a linkedin post" },
                  { key: "graphics_designer", value: "Generate a design on" },
                  { key: "blogger", value: "Write a blog on" },
                  { key: "facebook", value: "Create a Facebook post on" },
                  {
                      key: "instagram",
                      value: "Make an Instagram Story featuring",
                  },
                  { key: "file_master", value: "Make this file" },
                  { key: "twitter", value: "Write a tweet" },
              ];

    const [pausedRows, setPausedRows] = useState([false, false, false]);

    const handlePause = (index, value) => {
        const updated = [...pausedRows];
        updated[index] = value;
        setPausedRows(updated);
    };

    const getMarginTop = () => {
        if (screens.xl) return token.marginXXL;
        if (screens.lg) return token.marginXL;
        if (screens.md) return token.marginLG;
        return token.marginMD;
    };

    const getCardSize = () => {
        return screens.xs ? "small" : "default";
    };

    const getFontSize = () => {
        return screens.xs ? token.fontSizeSM : token.fontSizeLG;
    };

    const getGapSize = () => {
        return screens.xs ? "small" : "middle";
    };

    return (
        <div
            className={styles.scrollingChatTips}
            style={{ marginTop: getMarginTop() }}
        >
            {[0, 1, 2].map((rowIndex) => {
                const direction = rowIndex % 2 === 0 ? "left" : "right";
                return (
                    <div
                        key={rowIndex}
                        className={`${styles.scrollRow} ${
                            pausedRows[rowIndex] ? styles.paused : ""
                        }`}
                        onMouseEnter={() => handlePause(rowIndex, true)}
                        onMouseLeave={() => handlePause(rowIndex, false)}
                        style={{ marginBottom: token.marginMD }}
                    >
                        <Space
                            size={getGapSize()}
                            className={`${styles.scrollContent} ${
                                direction === "left"
                                    ? styles.scrollLeft
                                    : styles.scrollRight
                            }`}
                        >
                            {tips.concat(tips).map((item, i) => (
                                <Card
                                    key={i}
                                    // hoverable
                                    size={getCardSize()}
                                    style={{
                                        backgroundColor:
                                            token.colorFillQuaternary,
                                        borderRadius: token.borderRadiusLG,
                                        border: `1px solid ${token.colorBorderSecondary}`,
                                        minWidth: "max-content",
                                        flexShrink: 0,
                                        cursor: "pointer",
                                    }}
                                    styles={{
                                        body: {
                                            padding: screens.xs
                                                ? `${token.paddingXS}px ${token.paddingSM}px`
                                                : `${token.paddingSM}px ${token.paddingMD}px`,
                                        },
                                    }}
                                    onClick={() => {
                                        onSnippetClick(item.value);
                                        setAgent(item.key);
                                    }}
                                >
                                    <Text
                                        style={{
                                            // fontSize: getFontSize(),
                                            // fontWeight: token.fontWeightStrong,
                                            color: token.colorTextSecondary,
                                        }}
                                    >
                                        {item.value}
                                    </Text>
                                </Card>
                            ))}
                        </Space>
                    </div>
                );
            })}
        </div>
    );
}

export default ScrollingChatTips;
